<template>
  <div id="app" class="app">
    <header class="container">
      <nav class="navbar">
        <div v-if="alfSession.loggedIn" class="navbar-brand">
          <router-link :to="{path:'/'}" class="navbar-item" :class="{ 'is-active': $route.name==='Home' }">Accueil</router-link>

          <div v-if="alfSession.loggedIn" class="navbar-burger burger" data-target="livrenumMenu" @click="toggleMenu">
            <span></span>
            <span></span>
            <span></span>
          </div>

        </div>
        <div class="navbar-menu" id="livrenumMenu">
          <div class="navbar-start">
            <router-link v-if="alfSession.loggedIn" :to="{path:'/fiches'}" class="navbar-item" :class="{ 'is-active': $route.name==='Works' }"><span>Fiches</span></router-link>
            <router-link v-if="alfSession.loggedIn" :to="{path:'/createurs'}" class="navbar-item" :class="{ 'is-active': $route.name==='Actors' }"><span>Créateurs</span></router-link>
          </div>
          <div class="navbar-end">
            <alfresco :server-address="alfrescoHost" v-model="alfSession" class="navbar-item is-hidden-touch" @connect="connect"></alfresco>
          </div>
        </div>
      </nav>
    </header>

    <div class="container">
      <router-view v-if="alfSession.loggedIn"></router-view>
      <div v-else>
        <section class="hero is-info is-medium is-bold">
          <div class="hero-body">
            <div class="container">
              <h1 class="title"><i>{{ siteTitle  }}</i></h1>
              <p class="has-text-weight-normal">Bienvenue sur {{ siteTitle }}. Veuillez ouvrir une session...</p>
            </div>
          </div>
        </section>
      </div>
    </div>

    <footer v-if="alfSession.loggedIn" class="footer">
      <div class="container">
        <div class="has-text-centered">
          <div class="title is-4">&copy; 2019 - Laboratoire Ex situ</div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import Alfresco from './components/alfresco';

export default {
  name: 'app',
  components: { Alfresco },
  data: function() {
    return {
      alfSession: {}
    }
  },
  computed: {
    uploadUrl: function() {
      return this.alfSession.uploadUrl;
    },
    siteTitle: function() {
      return this.$store.state.siteTitle;
    },
    alfrescoHost: function() {
      return `//${this.$store.state.alfrescoHost}`;
    }
  },
  methods: {
    connect(session) {
      this.$store.commit('setCurrentUser', session.username);
      this.$store.commit('setUploadUrl', session.uploadUrl);
    },
    toggleMenu(e) {
      e.target.classList.toggle("is-active");
      document.getElementById(e.target.dataset.target).classList.toggle("is-active");
    }
  },
  created: function() {
    this.$store.dispatch('getWorks');
    this.$store.dispatch('getActors');
    
    document.title = this.$store.state.siteTitle;

    this.$router.beforeEach( (to, from, next) => {
      setPageMetadata(to);
      this.$store.dispatch('getWorks');
      this.$store.dispatch('getActors');
      window.scrollTo(0, 0);
      
      next();
    });
  }
}

function setPageMetadata(to) {
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  // const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  
  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  }

  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  if (nearestWithMeta) {
    nearestWithMeta.meta.metaTags.map(tagDef => {
      const tag = document.createElement('meta');
  
      Object.keys(tagDef).forEach(key => {
        tag.setAttribute(key, tagDef[key]);
      });
  
      tag.setAttribute('data-vue-router-controlled', '');
  
      return tag;
    })
    .forEach(tag => document.head.appendChild(tag));
  }
}
</script>


<style lang="scss">
  h1, h2, h3, h4, h5, h6 {
    font-size: 100%;
  }
  textarea {
    resize:none !important;
  }
  figcaption {
    color: #888;
  }
  footer {
    margin-top: 2em;
  }
  .input[type="search"],
  .textarea[type="search"] {
    border-radius: 3px !important;
  }

  select[multiple].multi-select {
      all: initial;
      font: inherit;
      overflow-y: auto;
      border-radius: 3px;
      padding-bottom: 0.5em;
      padding-left: 0.625em;
      padding-top: 0.5em;
      background-color: white;
      border: 1px solid #dbdbdb;
      color: #363636;
      cursor: pointer;
      display: block;
      outline: none;
      padding-right: 2.5em;
  }

  select[multiple].multi-select:active, select[multiple].multi-select:focus {
      border-color: #00d1b2;
  }

  .navbar {
    margin-bottom: 1em;
  }
  .navbar-item.is-active {
    border-bottom: 2px #00d1b2 solid !important;
  }
  .small-text {
    font-size: .85em;
  }
  .is-muted {
    color: #ccc !important;
  }
  .is-bold {
    font-weight: bold;
  }
  .ucFirst {
    display: inline-block;
    &:first-letter {
      text-transform: uppercase;
    }
  }
  .list-unstyled {
    margin: 0 !important;

    li {
      list-style-type: none;
    }
  }
  .is-link {
    text-decoration: none !important;
  }

  .info-block {
    margin-bottom: 1.5em;
  }
</style>
